import { z } from "zod";

import { strapiClient } from "@/lib/strapiClient";

const jobPostingLocalizationSchema = z.object({
	id: z.number(),
	documentId: z.string(),
	title: z.string(),
	location: z.string(),
	type: z.string(),
	description: z.string().nullable(),
	locale: z.string(),
});

export const jobPostingSchema = z.object({
	id: z.number(),
	documentId: z.string(),
	title: z.string(),
	location: z.string(),
	type: z.string(),
	description: z.string().nullable(),
	locale: z.string(),
	localizations: z.array(jobPostingLocalizationSchema).default([]),
});

export type JobPosting = z.infer<typeof jobPostingSchema>;

const jobPostingsCollection = strapiClient.collection("job-postings");

export async function getJobPostings(locale = "mk-MK"): Promise<JobPosting[]> {
	const response = await jobPostingsCollection.find({
		locale,
		populate: ["localizations"],
		sort: "publishedAt:desc",
	});
	return z.array(jobPostingSchema).parse(response.data);
}

export async function getJobPosting(
	documentId: string,
	locale = "mk-MK",
): Promise<JobPosting | null> {
	try {
		const response = await jobPostingsCollection.findOne(documentId, {
			locale,
			populate: ["localizations"],
		});
		return jobPostingSchema.parse(response.data);
	} catch {
		return null;
	}
}
